// Central API URL helper - checks localStorage first, then env variable
export const getApiUrl = () => {
  // 1. Check localStorage first (user can set custom URL)
  const storedUrl = localStorage.getItem('apiUrl');
  if (storedUrl) return storedUrl;
  
  // 2. Check if we're in a native Capacitor app (not just web with Capacitor bundled)
  if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
    return 'http://localhost:4000/api';
  }
  
  // 3. For web (including Capacitor web platform), use same protocol/host as frontend
  // This works for all cases:
  //   - http://riasdb02:4000      → http://riasdb02:4000/api
  //   - http://<server-ip>:4000     → http://<server-ip>:4000/api
  //   - https://workplaner.duckdns.org → https://workplaner.duckdns.org/api (Caddy proxies to backend)
  //   - http://localhost:3001     → http://localhost:4001/api (dev: form-app on 3001, server on 4001)
  //   - http://localhost:4000     → http://localhost:4000/api (production)
  const host = window.location.host;
  if (host === 'localhost:3001') {
    return 'http://localhost:4001/api';
  }
  return `${window.location.protocol}//${host}/api`;
};

// Get base server URL (without /api) for static files like uploads
export const getServerUrl = () => {
  const apiUrl = getApiUrl();
  // Remove '/api' from the end if it exists
  return apiUrl.replace(/\/api$/, '');
};

export default getApiUrl;
